import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import RoundLoading from "../Loading/RoundLoading";
import "./Login.css";
import client from "../../api/client";
import { AuthContext } from "../../contextStore/AuthContext";

function Login() {
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const safeTrim = (s) => (typeof s === "string" ? s.trim() : s);

  useEffect(() => {
    console.log("Login component mounted");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const id = safeTrim(identifier);
    if (!id || !password) {
      alert("Please enter email/phone and password.");
      setLoading(false);
      return;
    }

    try {
      const res = await client.post("/api/auth/login", {
        identifier: id,
        password,
      });

      const data = res.data;
      console.log("LOGIN response:", data);

      if (!data || data.ok === false) {
        const serverMsg = data?.error || data?.message || "Invalid credentials";
        alert(serverMsg);
        setLoading(false);
        return;
      }

      const token = data.token;
      const user = data.user;

      if (token) {
        try {
          client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        } catch (e) {
          console.warn("Login: could not set axios header", e);
        }

        try {
          localStorage.setItem("token", token);
          if (user) localStorage.setItem("user", JSON.stringify(user));
        } catch (e) {
          console.error("Login: localStorage set failed", e);
          alert("Unable to persist login token locally: " + e.message);
        }

        try {
          if (typeof setUser === "function") {
            setUser(user, token);
          }
        } catch (e) {
          console.warn("Login: setUser threw", e);
        }

        alert(`Welcome back, ${user?.name || "User"}!`);

        if (user && String(user.role || "").toLowerCase().includes("admin")) {
          navigate("/admin");
        } else {
          navigate("/");
        }
      } else {
        alert("Login succeeded but token missing. Please try again.");
      }
    } catch (err) {
      console.error("Login failed:", err);
      const serverMsg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Login failed — please try again.";
      alert(serverMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <RoundLoading />}
      <div className="login-container">
        <div className="login-card">
          {/* Header Section */}
          <div className="login-header">
            <div className="logo-container">
              <img src="/logo1.png" alt="Old Machine Market" className="login-logo" />
            </div>
            <h1 className="login-title">Welcome Back</h1>
            <p className="login-subtitle">Sign in to your account</p>
          </div>

          {/* Form Section */}
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="identifier" className="form-label">
                Email or Phone
              </label>
              <input
                id="identifier"
                className="form-input"
                type="text"
                placeholder="Enter your email or phone number"
                name="identifier"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <div className="password-header">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <button
                  type="button"
                  className="show-password-btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
              <input
                id="password"
                className="form-input"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              className="login-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="button-spinner"></div>
                  Signing In...
                </>
              ) : (
                "Sign In"
              )}
            </button>
          </form>

          {/* Footer Section */}
          <div className="login-footer">
            <p className="signup-text">
              Don't have an account?{" "}
              <Link to="/signup" className="signup-link">
                Sign up
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;